<template>
  <b-row>
    <b-col cols="4">

      <BfInput
        label="Nombre"
        data-key="nombre"
        :value="data.nombre"
        :edit-mode="editing"
        :errors="errors"
        @update="updateForm"
      />
    </b-col>
    <b-col cols="4">
      <BfInput
        label="Nif"
        data-key="nif"
        :value="data.nif"
        :edit-mode="editing"
        :errors="errors"
        @update="updateForm"
      />
    </b-col>

    <b-col cols="4">

    </b-col>

    <!--direccion-->

     <b-col cols="8">
      <BfInput
        label="Dirección"
        data-key="direccion"
        :value="data.direccion"
        :edit-mode="editing"
        :errors="errors"
        @update="updateForm"
      />
    </b-col>

     <b-col cols="4">

    </b-col>

    <!--direccion-->
     <b-col cols="3">
      <BfInput
        label="Código postal"
        data-key="codigopostal"
        :value="data.codigopostal"
        :errors="errors"
        @update="updateCp"
      />
    </b-col>

    <b-col cols="3">
      <BfInput
        label="Población"
        data-key="poblacion"
        :value="data.poblacion"
        :edit-mode="editing"
        :errors="errors"
        @update="updateForm"
        readonly
      />
    </b-col>

    <b-col cols="3">
      <BfInput
        label="Provincia"
        data-key="provincia"
        :value="data.provincia"
        :edit-mode="editing"
        :errors="errors"
        @update="updateForm"
        readonly
      />
    </b-col>


    <!--iban-->
    <b-col cols="6">
      <BfInput
        label="IBAN"
        data-key="iban"
        :value="data.iban"
        :edit-mode="editing"
        :errors="errors"
        @update="updateForm"
      />
    </b-col>
    <b-col cols="6" />

       <b-col cols="6">
      <BfInput
        label="Observaciones"
        data-key="observaciones"
        :value="data.observaciones"
        :edit-mode="editing"
        :errors="errors"
        @update="updateForm"
        type="textarea"
        :autosize="{ minRows: 5, maxRows: 10 }"

      />
    </b-col>
  </b-row>
</template>

<script>
export default {
  name: 'ClientForm',

  props: {
    data: {
      type: Object,
      default: () => ({}),
    },

    errors: {
      type: Object,
    },

    editing: {
      type: Boolean,
      default: false,
    },
  },

  methods: {
    updateForm(fieldData) {
      this.$emit('update', fieldData);
    },
    updateCp(fieldData) {
      this.$emit('updatecp', fieldData);
    },
  },
};
</script>
